import { MapStateToPropsFactory } from "react-redux";

import { ApplicationState, UserDetails } from "@ppb/tbd-store";
import { Jurisdiction } from "@ppb/tbd-store/state/constants";
import { Section } from "@ppb/tbd-store/state/layout/cards/regulatory-sections/RegulatorySections.types";
import { createGetCountryLocalCurrencyCodeSelector } from "@ppb/tbd-store/state/entities/user-details/user-details-selectors";
import { createGetRegulatoryDataSectionsSelector } from "@ppb/tbd-store/state/entities/regulatory-data/regulatory-data-selectors";

import type { RegulatorySectionsHeaderProps } from "./snowflakes/RegulatoryHeader/RegulatoryHeader.types";

type JurisdictionType = RegulatorySectionsHeaderProps["jurisdiction"];

export type StateProps = {
  regulatorySections?: Section[];
  jurisdiction: JurisdictionType;
};

export const makeMapStateToProps: MapStateToPropsFactory<StateProps, {}, ApplicationState> = () => {
  const getRegulatorySections = createGetRegulatoryDataSectionsSelector();
  const getUserDetailsSelector = createGetCountryLocalCurrencyCodeSelector();

  const baseVM = {
    jurisdiction: Jurisdiction.INTERNATIONAL,
  };

  return function mapStateToProps(state: ApplicationState): StateProps {
    let userDetails;

    try {
      userDetails = <UserDetails>getUserDetailsSelector(state);
    } catch (e) {
      console.error(e);
      return baseVM;
    }

    const { loggedIn, jurisdiction } = userDetails;
    const regulatorySections = getRegulatorySections(state.entities.regulatoryData, loggedIn);

    return {
      regulatorySections,
      jurisdiction: (jurisdiction?.jurisdiction as JurisdictionType) || baseVM.jurisdiction,
    };
  };
};
